// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"629":"90ac9abc","908":"19d09785","981":"b6545368"}[chunkId] + ".css";
};